var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.legendUrl)?_c('img',{staticClass:"layer-legend-image",attrs:{"src":_vm.legendUrl,"alt":'légende de la couche ' + _vm.layer.title,"data-test":"layerLegendImage"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }